import { hours } from './format';

/**
 * @param {Array} data
 *
 * @return {Number}
 */
export function getTotalDuration(data = []) {
  const totalDuration = data.reduce((a, b) => a + b.duration, 0);

  return hours(totalDuration);
}



// WEBPACK FOOTER //
// ./src/modules/common/utils/exchanges.js